import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import InfiniteScroll from 'react-infinite-scroller';

import { getUserWishlist } from 'Redux/ducks/wishlist';
import WishlistCard from 'Components/Wishlist/WishlistCard';
import WishlistSellingPoints from 'Components/Wishlist/WishlistSellingPoints';
import WishlistFriendsContainer from 'Containers/Wishlist/WishlistFriendsContainer';
import { history } from 'Redux/store';
import Loading from 'Components/Utility/Loading';
import 'Components/Wishlist/MyFriendsWishlist.scss';

let itemsToDisplay = [];

const MyFriendWishlistContainer = ({
  wishlistId,
  sort,
  friends,
  setPrivateWishlist,
  fromAccount,
}) => {
  const defaultWishlistData = {
    items: [],
    page: 1,
    nbPages: 0,
    isPrivate: false,
  };

  const [wishlistData, setWishlistData] = useState(defaultWishlistData);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    const loadUserWishlist = async () => {
      const data = await getUserWishlist(sort, 1, wishlistId);
      setHasLoaded(true);
      return setWishlistData(data);
    };

    setHasLoaded(false);
    itemsToDisplay = [];

    if (wishlistId) loadUserWishlist();
  }, [sort, wishlistId]);

  const { page, nbPages, items, wishlistDisplayName, isPrivate, doesNotExist } = wishlistData;
  if (page > 1) {
    itemsToDisplay = itemsToDisplay.concat(items);
  } else {
    itemsToDisplay = items;
  }

  const hasItems = !isEmpty(itemsToDisplay);
  const hasFriends = !isEmpty(friends);
  if (isPrivate) setPrivateWishlist(true);

  if (doesNotExist) {
    history.push({
      pathname: '/wishlist',
      search: '',
    });
  }

  return (
    <div className="wishlist-friends-container">
      <div className="left-column">
        <WishlistFriendsContainer
          wishlistId={wishlistId}
          wishlistDisplayName={wishlistDisplayName}
          isPrivate={isPrivate}
          fromAccount={fromAccount}
        />

        {((!wishlistId && !hasFriends) || (isPrivate && !hasFriends)) &&
          <div className="wishlist-message-box mb-4">
            <p className="mb-0">
              <FormattedMessage id="myfriendswishlist.title.nofriendsmessage" defaultMessage="You do not have any shared wishlists yet." />
            </p>
          </div>
        }
      </div>

      <div className="right-column">
        {!wishlistId &&
          <WishlistSellingPoints myFriends />
        }

        {wishlistId && !hasLoaded &&
          <Loading />
        }

        {isPrivate &&
          <div className="wishlist-message-box">
            <h3>
              <FormattedMessage id="myfriendswishlist.title.wishlistisprivate" defaultMessage="This wishlist is private" />
            </h3>
          </div>
        }

        {!hasItems && hasLoaded && !isPrivate &&
          <div className="wishlist-message-box">
            <h3>
              <FormattedMessage id="myfriendswishlist.title.userswishlistempty" defaultMessage="This user's wishlist is empty" />
            </h3>
          </div>
        }

        {hasItems && hasLoaded &&
          <div className="infinite-wrap" key={page}>
            <InfiniteScroll
              pageStart={page || 1}
              loadMore={async (pageValue) => {
                const data = await getUserWishlist(sort, pageValue, wishlistId);
                setWishlistData(data);
              }}
              hasMore={!!(itemsToDisplay.length && page < nbPages)}
              initialLoad={false}
              loader={<div className="infinite-loader" key={0}>
                <div className="spinner">
                  <div className="rect1" />
                  <div className="rect2" />
                  <div className="rect3" />
                  <div className="rect4" />
                  <div className="rect5" />
                </div>
              </div>}
            >

              {itemsToDisplay.map(hit =>
                <div key={hit.objectID}>
                  <WishlistCard
                    giftButton
                    hit={hit}
                    key={hit.objectID}
                    displayName={wishlistDisplayName}
                    wishlistId={wishlistId}
                  />
                </div>,
              )}
            </InfiniteScroll>
          </div>
        }
      </div>
    </div>
  );
};


MyFriendWishlistContainer.propTypes = {
  wishlistId: PropTypes.string,
  sort: PropTypes.string.isRequired,
  friends: PropTypes.arrayOf(PropTypes.object),
  setPrivateWishlist: PropTypes.func.isRequired,
  fromAccount: PropTypes.bool,
};

MyFriendWishlistContainer.defaultProps = {
  authenticated: false,
  friends: [],
  wishlistId: '',
  fromAccount: false,
};

const mapStateToProps =
({
  auth: { authenticated },
  wishlist: { friends },
}) => ({
  authenticated,
  friends,
});

export default connect(mapStateToProps)(MyFriendWishlistContainer);
